import React, { useState, useEffect } from "react";
import axios from "axios";
import { NavLink } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import RealTimeService from "../../../../app/realtime/RealTimeService";
import { FormattedMessage } from "react-intl";
import { shallowEqual, useSelector } from "react-redux";


export function ConnectionsStatusIndicator() {

    const [status, setStatus ] = useState('success');

    const modules = useSelector(({ auth }) => auth.user.modules, shallowEqual);
    
    const fetchConnectionStatus = async () => {
      
      try {
        const response = await axios.get(`${process.env.REACT_APP_URL}/module/SERV/dataflows`)
        setStatus(response.data.Status === "CONNECTED" ? "success" : "error" );
      } catch {
        setStatus("error");
      }
    };

    useEffect(() => {
      let timeout = null;
      if (modules.find(module => module.code === "SERV")?.isActivated) {
        fetchConnectionStatus();
      }
      RealTimeService.subscribe("SERV", "STATUS", (data) => {
        
        if(timeout)
          clearTimeout(timeout);
        timeout = setTimeout(() => { fetchConnectionStatus(); }, 250);
      } );
    }, [modules])

  const statusSuccess = (
    <div className="btn btn-icon btn-light-success mr-5">
      <i className="flaticon2-accept"> </i>
    </div>
  );

  const statusError = (
    <div className="btn btn-icon btn-light-danger pulse pulse-danger mr-5">
      <i className="flaticon2-information"></i>
      <span className="pulse-ring"></span>
    </div>
  );

  

  return (
    <>
    { modules.find(module => module.code === "SERV")?.isActivated &&
      <>
        <span className="text-dark-50 font-size-base d-none d-md-inline mr-3">
        <FormattedMessage id="SYSTEM.CONNECTION.STATUS"/> :
      </span>
      <NavLink to="/connections">
        <OverlayTrigger placement="bottom"
        overlay={
          <Tooltip id="tooltip-status">
            <FormattedMessage id="SYSTEM.CONNECTION.STATUS"/>
          </Tooltip>
        }>
        {status === 'success' ? statusSuccess : statusError }
        </OverlayTrigger>
      </NavLink>
      </>
    }
    </>
  );
}
